
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/desarrollos/thankyoupage-brochure",
      function () {
        return require("private-next-pages/desarrollos/thankyoupage-brochure.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/desarrollos/thankyoupage-brochure"])
      });
    }
  